export default `---
slug: mexico
country: Mexico
countryCode: MEX
continent: America
year: 2024
title: "Mexico"
description: "Ancient pyramids, vibrant street food, colonial cities, and Caribbean beaches — a kaleidoscope of cultures and landscapes."
thumbnail:
relatedLinks: []
---

*Story coming soon — stay tuned!*
`;
